import React, { ReactNode, Ref, RefObject } from 'react';
import { Button } from '@ardoq/button';
import { AnimatedChevron, Icon, IconName, IconSize } from '@ardoq/icons';

type DropdownButtonProperties = {
  iconName?: IconName;
  iconSize?: IconSize;
  hideChevron?: boolean;
  isOpen: boolean;
  onClick?: (e: React.MouseEvent) => void;
  isDisabled?: boolean;
  tooltipText?: string;
  hostRef: RefObject<HTMLElement | null>;
  isActive?: boolean;
  children: ReactNode;
};
export const DropdownButton = ({
  iconName,
  hideChevron,
  isOpen,
  onClick,
  isDisabled,
  iconSize,
  tooltipText,
  hostRef,
  isActive,
  children,
  ...props
}: DropdownButtonProperties) => (
  <Button
    onClick={onClick}
    data-tooltip-text={tooltipText}
    data-is-active={isOpen}
    data-is-disabled={isDisabled}
    ref={hostRef as Ref<HTMLButtonElement>}
    isActive={isActive || isOpen}
    isDisabled={isDisabled}
    aria-haspopup="listbox"
    aria-expanded={isOpen}
    {...props}
  >
    {iconName && <Icon iconName={iconName} iconSize={iconSize} />}
    {children}
    {!hideChevron && !iconName && <AnimatedChevron $isUp={isOpen} />}
  </Button>
);
